import { Button } from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"
import InputTextField from "src/components/atom/InputTextField"
import { OutlinedButton } from "src/components/buttons/OutlinedButton"
import { Box } from "src/UILibrary"

type Props = {
  email: string
  handleEmail: any
  password: string
  handlePassword: any
  passwordConfirm: any
  handlePasswordConfirm: any
  emailValidationMessage: any
  passwordValidationMessage: any
  passwordConfirmValidationMessage: any
  handlePrev: () => void
  handleNext: () => void
}

export const CompanyLoginInformation = ({
  email,
  handleEmail,
  password,
  handlePassword,
  passwordConfirm,
  handlePasswordConfirm,
  emailValidationMessage,
  passwordValidationMessage,
  passwordConfirmValidationMessage,
  handlePrev,
  handleNext,
}: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "mypage.user" })

  return (
    <Box maxWidth="md">
      <InputTextField
        name={t("email")}
        required
        text={email}
        handleText={handleEmail}
        validationMessage={emailValidationMessage}
        maxLength={50}
        sx={{ mt: "40px" }}
      ></InputTextField>
      <InputTextField
        name={t("password")}
        required
        text={password}
        description={t("password_description")}
        handleText={handlePassword}
        validationMessage={passwordValidationMessage}
        maxLength={50}
        sx={{ mt: "40px" }}
        password
      ></InputTextField>
      <InputTextField
        name={t("password_confirm")}
        required
        text={passwordConfirm}
        description={t("password_confirm_description")}
        handleText={handlePasswordConfirm}
        validationMessage={passwordConfirmValidationMessage}
        maxLength={50}
        sx={{ mt: "40px" }}
        password
      ></InputTextField>
      <Box display="flex" sx={{ mt: "40px" }}>
        <OutlinedButton
          caption={t("back")}
          fontColor="primary.main"
          fontWeight="700"
          sx={{
            borderColor: "primary.main",
            minWidth: "240px",
            py: "16px",
            px: "88px",
            fontSize: "1rem",
            fontFamily: "Noto Sans JP !important",
            lineHeight: "1rem",
            fontWeight: 700,
            ml: "auto",
            mr: "40px",
            display: "flex",
            justifyContent: "center",
            borderRadius: 0,
          }}
          onClick={() => handlePrev()}
        />
        <Button
          variant="contained"
          sx={{
            minWidth: "240px",
            py: "16px",
            px: "88px",
            fontSize: "1rem",
            fontFamily: "Noto Sans JP !important",
            lineHeight: "1rem",
            fontWeight: 700,
            ml: 0,
            mr: "auto",
            display: "flex",
            justifyContent: "center",
            borderRadius: 0,
            ":hover": {
              bgcolor: "#2DA389",
            },
          }}
          onClick={() => handleNext()}
        >
          {t("next")}
        </Button>
      </Box>
    </Box>
  )
}
